import axios from "@/utils/axios.js";

/**
 * 经济人认证-发送短信
 * phoneNum：手机号
 */
export async function getCode(phoneNum) {
  return axios.get(`/agentLogin/generateVerCodeXcx/${phoneNum}`);
}

/**
 * 经济人认证-认证提交
 * agentTel: 手机号
 * verCode: 验证码
 * owxOpenId: openid
 */
export async function submitVer(params) {
  return axios.post("/agentLogin/brokerVerificationNew", params);
}

/**
 * 新经济人认证-认证提交
 */
export async function newSubmitVer(params) {
  return axios.post("/agentAccount/agentAuthenticationByCityOpenId", params);
}
